import { useState, useEffect, useContext } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { CommonServiceContext } from "../services/common/commonService";
import Loader from "../components/Loader";
import RecaptchaComponent from "../components/RecaptchaComponent";
import MaskedInput from "react-text-mask";
import { useUserContext } from "../context/user_context";
import CustomAlert from "../components/CustomAlert";
import { set } from "date-fns";

const AskContract = () => {
  const { askContract, loading } = useContext(CommonServiceContext);
  const navigate = useNavigate();
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const { captchaState, setCaptchaState } = useUserContext();
  const [formData, setFormData] = useState({
    name: "",
    idNumber: "",
    contactPersonName: "",
    contactPhone: "",
    contactEmail: "",
  });
  const [errors, setErrors] = useState({});

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  useEffect(() => {
    setCaptchaState({ ...captchaState, ask: true });
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;
    if (name === "contactPhone") {
      value = value.replace(/[^0-9]/g, "");
    }
    value = value.trim();
    //console.log([name, value]);
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const response = await askContract(formData);
    setResetCaptcha(!resetCaptcha);
    setCaptchaState({ ask: false, token: null });
    if (response && response.data) {
      if (response.data.success) {
        setAlertConfig({
          show: true,
          title: "მოთხოვნა წარმატებით გაიგზავნა",
          icon: "success",
          onCancel: () => {
            setAlertConfig({ ...alertConfig, show: false });
            navigate("/");
          },
        });
      } else {
        setAlertConfig({
          show: true,
          title: "მოთხოვნა ვერ გაიგზავნა",
          text: response.data.message,
          icon: "error",
          onCancel: () => {
            setAlertConfig({ ...alertConfig, show: false });
          },
        });
      }
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (
      !captchaState.token ||
      captchaState.token === "" ||
      captchaState.token === null ||
      captchaState.token === undefined ||
      captchaState.token === "null"
    ) {
      newErrors.recaptchaCode = "მონიშნეთ reCAPTCHA";
    }

    if (!formData.name.trim()) {
      newErrors.name = "საჭიროა კომპანიის დასახელება";
    }

    if (!formData.idNumber.trim()) {
      newErrors.idNumber = "საჭიროა კომპანიის საიდენტიფიკაციო კოდი";
    }

    if (!formData.contactPersonName.trim()) {
      newErrors.contactPersonName = "საჭიროა საკონტაქტო პირი";
    }

    const phone = formData.contactPhone.replace(/[^0-9]/g, "");

    if (!phone.trim()) {
      newErrors.contactPhone = "ნომერი აუცილებელია";
    } else if (phone.trim().length !== 9) {
      newErrors.contactPhone = "არასწორი ნომერი";
    }

    if (!formData.contactEmail.trim()) {
      newErrors.contactEmail = "საჭიროა საკონტაქტო ელ. ფოსტა";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <>
      <CustomAlert {...alertConfig} />
      {loading && <Loader />}
      <form onSubmit={handleSubmit}>
        <div className="form-control mb-5">
          <label className="block text-sm font-medium mb-2" htmlFor="name">
            კომპანიის დასახელება
          </label>
          <input
            type="text"
            id="name"
            name="name"
            placeholder="დასახელება"
            className="w-full px-3 py-2 border border-border-color rounded-md"
            required
          />
          {errors.name && (
            <div className="text-danger text-[14px]/[20px]">{errors.name}</div>
          )}
        </div>
        <div className="form-control mb-5">
          <label className="block text-sm font-medium mb-2" htmlFor="idNumber">
            კომპანიის საიდენტიფიკაციო კოდი
          </label>
          <input
            type="text"
            id="idNumber"
            name="idNumber"
            placeholder="საიდენტიფიკაციო კოდი"
            className="w-full px-3 py-2 border border-border-color rounded-md"
            required
          />
          {errors.idNumber && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.idNumber}
            </div>
          )}
        </div>
        <div className="form-control mb-5">
          <label
            className="block text-sm font-medium mb-2"
            htmlFor="contactPersonName"
          >
            საკონტაქტო პირი (სახელი, გვარი)
          </label>
          <input
            type="text"
            id="contactPersonName"
            name="contactPersonName"
            placeholder="საკონტაქტო პირი"
            className="w-full px-3 py-2 border border-border-color rounded-md"
            required
          />
          {errors.contactPersonName && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.contactPersonName}
            </div>
          )}
        </div>
        <div className="form-control mb-5">
          <label
            className="block text-sm font-medium mb-2"
            htmlFor="contactPhone"
          >
            საკონტაქტო ტელეფონის ნომერი
          </label>
          <MaskedInput
            mask={[
              "(",
              /[0-9]/,
              /\d/,
              /\d/,
              ")",
              " ",
              /\d/,
              /\d/,
              /\d/,
              "-",
              /\d/,
              /\d/,
              /\d/,
            ]}
            guide={true}
            id="contactPhone"
            className="form-input"
            required
            type="text"
            placeholder="(555) 555-555"
            name="contactPhone"
            onChange={handleChange}
            autoComplete="off"
          ></MaskedInput>
          {errors.contactPhone && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.contactPhone}
            </div>
          )}
        </div>
        <div className="form-control mb-5">
          <label className="block text-sm font-medium mb-2" htmlFor="email">
            ელ. ფოსტა
          </label>
          <input
            type="email"
            id="contactEmail"
            name="contactEmail"
            className="w-full px-3 py-2 border border-border-color rounded-md"
            required
          />
          {errors.contactEmail && (
            <div className="text-danger text-[14px]/[20px]">
              {errors.contactEmail}
            </div>
          )}
        </div>
        <div className="">
          {captchaState.ask && (
            <>
              <div
                className="flex mb-20"
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div className="auth-err-cont" style={{ marginTop: "10px" }}>
                  <RecaptchaComponent reset={resetCaptcha} />
                </div>
                {errors.recaptchaCode && (
                  <div className="text-danger text-[14px]/[20px]">
                    {errors.recaptchaCode}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
        <div className="flex justify-end">
          <button
            type="submit"
            className="px-4 py-2 bg-primary text-white rounded-md hover:bg-secondary transition-all"
          >
            მოთხოვნა
          </button>
        </div>
      </form>
    </>
  );
};

export default AskContract;
